export const RatingColor = {
  Gold: 'Gold',
  Primary: 'Primary',
  Inactive: 'Inactive',
  InactiveInverted: 'InactiveInverted',
} as const;

export type RatingColorT = (typeof RatingColor)[keyof typeof RatingColor];

// Object-lookup + `satisfies` keeps this exhaustive without an `as` cast (rule 03),
// mirroring the `tagByLevel` pattern in `typography/heading/Heading.tsx`.
const colorValueByToken = {
  [RatingColor.Gold]: 'var(--color-gold)',
  [RatingColor.Primary]: 'var(--color-primary)',
  [RatingColor.Inactive]: 'oklch(from var(--color-background) l c h / 0.2)',
  [RatingColor.InactiveInverted]: 'oklch(from var(--color-foreground) l c h / 0.1)',
} satisfies Record<RatingColorT, string>;

export function getRatingColor(color: RatingColorT): string {
  return colorValueByToken[color];
}
